export const getBrowser = () => {
  const { userAgent } = navigator
  const browserVersion = (browserName: string) => userAgent.split(browserName)[1].split(' ')[0]

  if (userAgent.match(/edg/i)) {
    return { name: 'edge', version: browserVersion('Edg/') }
  }
  if (userAgent.match(/chrome|chromium|crios/i)) {
    return { name: 'chrome', version: browserVersion('Chrome/') }
  }
  if (userAgent.match(/firefox|fxios/i)) {
    return { name: 'firefox', version: browserVersion('Firefox/') }
  }
  if (userAgent.match(/safari/i)) {
    return { name: 'safari', version: browserVersion('Safari/') }
  }
  if (userAgent.match(/opr\//i)) {
    return { name: 'opera', version: browserVersion('Opera/') }
  }

  return { name: 'No browser detected', version: '' }
}

export const getSystemName = () => {
  const userAgent = navigator.userAgent

  if (userAgent.indexOf('Win') !== -1) return 'Windows'
  if (userAgent.indexOf('Mac') !== -1) return 'MacOS'
  if (userAgent.indexOf('X11') !== -1) return 'UNIX'
  if (userAgent.indexOf('Linux') !== -1) return 'Linux'

  return 'No system detected'
}
